export default [
  {
    title: 'Great for diners',
    content:
      'First Table is the perfect incentive for diners to eat out at new places. We’re connecting locals to the best hospitality a city has to offer – whether it’s new openings, industry mainstays, or the best-kept secrets. Our early bird incentive gives food lovers a reason to explore more of the menu which they may not have ordered otherwise, and experience the restaurant how the chef would like, a full experience.',
  },
  {
    title: 'Smart for restaurants',
    content:
      'We’re all guilty of walking past empty eateries in search of ones with more happy customers inside, but, as is the case for even the most sought-after restaurants, early dining times can be hard to fill. First Table helps combat slow starts to evenings by leveraging an otherwise empty table with a deal on food, and as a result, over [restaurants] restaurants are generating incremental revenue from their ‘first tables’.',
  },
  {
    title: 'Everyone wins',
    content:
      'It’s a win-win model for diners and restaurants and there’s no surprises at bill time. We’ve created a recipe for success whereby there’s one table available for breakfast, lunch or dinner each day, and it’s first-come, first-served. Needless to say, the largest win for restaurants is when customers who have experienced a half-price deal come back to pay full price, which we see time and time again.',
  },
];
